import PropTypes from 'prop-types';

export function RecordLabel({
  size,
  ...props
}) {
  return <i className="icon icon-record-label" style={{ transform: 'translateX(-4pt)', fontSize: size }} {...props} />
}

RecordLabel.propTypes = {
  size: PropTypes.number
}

export default RecordLabel;